var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 37,
    height: 30,
    rx: 8,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8377 11.9051C26.6293 15.3737 25.0251 17.108 23.1527 17.7661C21.4357 18.3696 19.5643 18.3696 17.8474 17.7661C15.9749 17.108 14.3707 15.3737 11.1623 11.9051L9.40835 10.009C7.09253 7.50544 5.93462 6.25364 5.86757 5.18848C5.80673 4.22204 6.21613 3.28566 6.9669 2.67407C7.79437 2 9.49958 2 12.91 2L28.09 2C31.5004 2 33.2056 2 34.0331 2.67407C34.7839 3.28566 35.1933 4.22204 35.1324 5.18848C35.0654 6.25365 33.9075 7.50544 31.5916 10.009L29.8377 11.9051Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.43b1a73c1db7a567f94f009749c40ee2.svg";
export { ForwardRef as ReactComponent };